// extracted by mini-css-extract-plugin
export default {"clickableNoun":"StandaloneTeddy_clickableNoun__MI7O4"};